<template>
  <div class="mcp-usage-cards">
    <McpUsageStatCard
      v-for="card in cards"
      :key="card.testId"
      :data-testid="card.testId"
      v-bind="card"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { McpUsageResponse } from '@/composables/mcp/useMcpUsage';

import McpUsageStatCard from './McpUsageStatCard.vue';

const { data } = defineProps<{
  data: McpUsageResponse | null;
}>();

type McpUsageCard = {
  testId: string;
  label: string;
  value: number | null | undefined;
  caption: string;
  isCallout?: boolean;
};

const cards = computed<McpUsageCard[]>(() => [
  {
    testId: 'mcp-usage-total-tool-calls',
    label: 'Total Tool Calls',
    value: data?.total_tool_calls,
    caption: 'Tool definitions may change during beta, affecting call counts',
    isCallout: true,
  },
  {
    testId: 'mcp-usage-weekly-active-users',
    label: 'Weekly Active Users',
    value: data?.weekly_active_users,
    caption: 'Rolling 7-day window',
  },
  {
    testId: 'mcp-usage-avg-weekly-tool-calls',
    label: 'Avg. Weekly Tool Calls',
    value: data?.avg_weekly_tool_calls,
    caption: 'Across your organization',
  },
]);
</script>
<style scoped lang="pcss">
@reference "../../css/theme.css";
.mcp-usage-cards {
  @apply grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-16;
}
</style>
